var script = {
  name: 'SliderMark',
  props: {
    mark: {
      type: [String, Number, Object],
      default: null
    }
  },
  computed: {
    label() {
      if (typeof this.mark === 'string') {
        return this.mark;
      }
      return this.mark.label;
    }
  }
};

export { script as default };
//# sourceMappingURL=mark.vue2.js.map
